import { ActivityLogGetters } from './partials/activity-log'
import { AssociateRecordGetters } from './partials/associate-records'
import { PrintRecordGetters } from './partials/print-record'
import { RecordEditGetters } from './partials/edit'

export const RecordGetters = {
  ...ActivityLogGetters,
  ...AssociateRecordGetters,
  ...PrintRecordGetters,
  ...RecordEditGetters,

  currentRecord: state => state.record,
  isLoading: state => state.isSearching,
  records: state => state.records,
}
